import { cn } from "@/lib/utils";

/**
 * Skip to main content link for keyboard navigation accessibility
 * WCAG 2.1 AA Compliance - Bypass Blocks (2.4.1)
 */
const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:z-[9999]",
        "focus:top-4 focus:left-4 focus:px-4 focus:py-2",
        "focus:bg-primary focus:text-primary-foreground",
        "focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring",
        "font-medium text-sm"
      )}
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
